import React, {Component} from 'react';
import { reduxForm, Field } from 'redux-form'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { PropTypes } from 'prop-types';
import ReactLoading from "react-loading";
import {
  CardHeader, CardTitle, Row, Label, 
  Col, Card, CardBody, 
  Button, Input, InputGroup, InputGroupAddon, 
  InputGroupText, FormGroup 
} from 'reactstrap';

import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { logout } from '../../../views/client/actions'

// Import actions
import changePassRequest from './actions';
import {
  CHANGE_PASS_SUCCESS,
} from './constants'

class ChangePass extends Component {
  // Pass the correct proptypes in for validation
  static propTypes = {
    handleSubmit: PropTypes.func,
    changePassRequest: PropTypes.func,
    logout: PropTypes.func,
    changePass: PropTypes.shape({
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    })
  }
 
  constructor(props) {
    super(props);
    
    this.state = {
      redirect: false,
    };
    this.toggleCancel = this.toggleCancel.bind(this);
    this.toggle2FA = this.toggle2FA.bind(this);
  }

  submit = (values) => {
    this.props.changePassRequest(values)
  }

  toggleCancel() {
    this.setState(state => ({
      redirect: true
    }));
  }

  toggle2FA() {
    this.props.history.push('/twofasetting');
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.changePass.type == CHANGE_PASS_SUCCESS){
      setTimeout(() => {
        this.props.logout();
        this.props.history.push('/login');
      }, 3 * 1000)
    }
  }

  render() {

    const {  
      handleSubmit, // remember, Redux Form injects this into our props
      changePass: {
        requesting,
        messages,
        errors,
      },
    } = this.props

    return (
      <div className="animated fadeIn">
          <Row className="justify-content-center">
            <Col md="12">
                <Card>
                  <CardHeader>
                    <i className="fa fa-key"></i>Đổi mật khẩu
                  </CardHeader>
                  <CardBody className="card-body">
                    <form className="widget-form" method="post" onSubmit={handleSubmit(this.submit)}>
                    <FormGroup row>
                    <Col md="6" xs="12" className="wallet-address">
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock mr-1"></i>Mật khẩu(*)
                          </InputGroupText>
                        </InputGroupAddon>
                        <Field name="current_password" type="password" placeholder="Mật khẩu hiện tại"  className="password" component="input" className="form-control" />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock mr-1"></i>Mật khẩu mới(*)
                          </InputGroupText>
                        </InputGroupAddon>
                        <Field name="password" type="password" maxLength="50" placeholder="Mật khẩu phải lớn hơn 6 kí tự"  className="password" component="input" className="form-control" />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock mr-1"></i>Xác nhận mk(*)
                          </InputGroupText>
                        </InputGroupAddon>
                        <Field name="password_confirmation" maxLength="50" placeholder="Xác nhận mật khẩu mới" type="password"  className="password" component="input" className="form-control" />
                      </InputGroup>
                    </Col>
                  </FormGroup>
                  <Row>
                    <Col md="6" xs="12">
                      {this.state.redirect && (
                        <Redirect to='/myaccount' />
                      )}
                      {requesting && (
                        <ReactLoading type="bubbles" color="#fff" />
                      )}
                      {!requesting && !!errors.length && (
                        <Errors message="Failure to signup due to:" errors={errors} />
                      )}
                      {!requesting && !!messages.length && (
                        <Messages messages={messages} />
                      )}  
                    </Col>
                  </Row>
                    <Row>
                      <Col md="6" xs="12">
                        <Button color="primary" className="btn btn-brand" action="submit"><i className="fa fa-save"></i>&nbsp;Lưu</Button>
                      </Col>
                    </Row>
                    </form>
                  </CardBody>
                </Card>
            </Col>
          </Row>
      </div>
    );
  }
}

// Grab only the piece of state we need
const mapStateToProps = state => ({
  changePass: state.changePass,
})

// make Redux state piece of `login` and our action `loginRequest`
// available in this.props within our component
const connected = connect(mapStateToProps, { changePassRequest, logout })(ChangePass)

// in our Redux's state, this form will be available in 'form.login'
const formed = reduxForm({
  form: 'changePass',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Pages/ChangePassword/ChangePassword.js